import Purchase from '@/pages/Purchase'

export default {
  path: '/purchase/',
  name: 'Purchase',
  component: Purchase
}



// WEBPACK FOOTER //
// ./src/router/purchase.js